<script>
    import { onDestroy, onMount } from "svelte";
    import { _ } from "svelte-i18n";
    import { navigate } from "svelte-routing";
    import { v4 as uuid } from "uuid";
    import { app } from "../../firebase";

    export let path;
    export let query = null;
    export let where = null;
    export let sort = null;
    export let writable = true;
    const db = app.firestore();

    const getQuery = (query, path, sort) => {
        if (query) return query;
        let builtQuery = db.collection(path);
        if (sort) builtQuery = builtQuery.orderBy(sort.field, sort.order);
        if (where)
            builtQuery = builtQuery.where(where.field, where.op, where.value);
        return builtQuery;
    };

    $: _query = getQuery(query, path, sort);

    let subscription;

    let collection = [];

    onMount(() => {
        subscription = _query.onSnapshot((snapshot) => {
            collection = snapshot.docs.map((doc) => {
                const data = { uid: doc.id };
                Object.entries(doc.data()).forEach(([key, value]) => {
                    if (!value) return;
                    data[key] = value.toDate ? value.toDate() : value;
                });
                return data;
            });
        });
    });

    onDestroy(() => {
        if (subscription) subscription();
    });

    const handleCreate = () => {
        navigate(`/${path}/${uuid()}`);
    };
</script>

{#if writable}
    <div class="flex justify-end">
        <button on:click={handleCreate}>{$_('Form.Create')}</button>
    </div>
{/if}

<slot {collection} />
